"use client";

import { Locale, defaultLocale, getDir, locales } from "@/lib/localization";
import { useLomdaV3Editor } from "../store/useLomdaV3Editor";

export const lomdaLocaleOf = (language: string | undefined): Locale =>
    locales.includes(language as Locale) ? (language as Locale) : defaultLocale;

/** The lomda's own language, for learner-facing text the author also sees
 *  on the canvas — pass it to `t()` explicitly, never rely on the UI locale. */
export function useLomdaLocale(): Locale {
    return lomdaLocaleOf(useLomdaV3Editor((s) => s.metadata.language));
}

/** From the raw stored language, so a legacy code like "es" stays LTR. */
export function useLomdaDir(): "rtl" | "ltr" {
    const language = useLomdaV3Editor((s) => s.metadata.language);
    return getDir(language as Locale);
}
